import logo from "../assets/images/logo.png";
import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { errorHandler } from "../utils/HelperFunctions";
import "../assets/css/login.css";
import useToast from "../components/common/useToast";
import apiFunctions from "../services/api-service";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";


const ForgetPasswordPage: React.FC = () => {
  const { showToast }: any = useToast();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/admin/login");
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Enter valid username address")
      .required("Username is required!"),
  });

  const initialValue = {
    email: "",
  };

  const login = (payload: any) => {
    apiFunctions
      .post(`/company/login`, payload)
      .then((response) => {
        if (response && response.data && response.data.success) {
          let data = JSON.stringify(response.data.data);
          localStorage.setItem("userDetails", data);
          localStorage.setItem("userToken", response.data.token);
          localStorage.setItem("setLoggedIn", String(true));
          localStorage.setItem(
            "timeout",
            String(new Date().setMinutes(new Date().getMinutes() + 15))
          );
          if (response.data.data.role === "superadmin") {
            navigate("/admin/company");
          } else {
            navigate("/admin/category");
          }
        } else {
          showToast({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }
      })
      .catch((err: AxiosError) => {
        errorHandler(err);
      });
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: validationSchema,

    onSubmit: async (values: any) => {
      let payload = {
        email: values.email,
      };
      login(payload);
    },
  });

  return (
    <form action="submit" onSubmit={formik.handleSubmit}>
      <div className="grid main-container justify-center items-center">
        <div className="grid form-container">
          <div className="login-logo">
            <img src={logo} alt="logo" className="mainlogo" />
            {/* <h1 className="m-0">Sagar Samaj</h1> */}
          </div>
          <div className="grid grid-cols-12 gap-4 mt-4">
            <div
              className="col-span-6 form-label justify-start cursor-pointer gap-2"
              onClick={handleBack}
            >
              <ArrowLeftIcon className="w-6 h-6 text-black-700" />
              Back
            </div>
          </div>
          <div className="form-inputs">
            <div className="mt-3">
              <label className="form-label" htmlFor="email">
                Username
              </label>
              <InputText
                className={`form-control ${formik.touched.email && formik.errors.email ? "p-invalid" : ""
                  }`}
                id="email"
                name="email"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email && (
                <span id="email-help" className="p-error text-left mt-2">
                  {formik.errors.email as string}
                </span>
              )}
            </div>
            <div className="field mt-5 mb-4">
              <Button
                label="SUBMIT"
                className="prime-button btn-login"
                type="submit"
              ></Button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ForgetPasswordPage;
